import { Disclosure, Transition } from "@headlessui/react"
import { FaChevronDown } from "../../../svgIcons"

export const FAQList = ({ faqs }) => {
  return (
    <div className="container flex flex-col items-center justify-center w-11/12 mx-auto md:w-9/12">
      {faqs.map(({ uid, question, answer }, index) => (
        <Disclosure key={uid} defaultOpen={false}>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex justify-between items-center rounded w-full px-4 md:px-12 h-16 text-secondary border border-[#E8EFFF]">
                <ul className="mr-6 text-left">
                  <li>{question}</li>
                </ul>
                <div className="text-primary">
                  <FaChevronDown className="w-4 h-4"/>
                </div>
              </Disclosure.Button>
              <div className="w-full">
                <Transition
                  enter="transition duration-100 ease-out"
                  enterFrom="transform scale-95 opacity-0"
                  enterTo="transform scale-100 opacity-100"
                  leave="transition duration-75 ease-out"
                  leaveFrom="transform scale-100 opacity-100"
                  leaveTo="transform scale-95 opacity-0"
                >
                  <Disclosure.Panel className="w-full px-12 py-6 text-secondary bg-bgcard">
                    <p
                      className="text-sm font-light faqItem md:w-3/4 text-secondary"
                      dangerouslySetInnerHTML={{
                        __html: `${answer}`,
                      }}
                    />
                  </Disclosure.Panel>
                </Transition>
              </div>
            </>
          )}
        </Disclosure>
      ))}
    </div>
  )
}
